module.exports = () ->
  return {
    restrict: 'A'
    scope:
      sources:         '&'
      label:           '@'
      activeWorker:    '='
      running:         '&'
      total:           '&?'
      hideCounts:      '@?'
      isManualChecks:  '@?'
      hasFailed:       '='

      # Delegates to multi-select-facet directive
      refineSearch:    '=?'
      sourcesFacet:    '=?'
      includeSources:  '=?'
      excludeSources:  '=?'
      facetSelectionEnabled: '=?sourceContainerFacetSelectionEnabled'


    controller: ( $scope, $stateParams, User ) ->
      if not angular.isDefined($scope.facetSelectionEnabled)
        $scope.facetSelectionEnabled = true

      $scope.User = User

      $scope.getSourceCount = () ->
        $scope.sources().length

      $scope.showProgressBar = $scope.total?()?

      $scope.isActiveSource = ( source ) ->
        source.id == +$stateParams.workerId

      $scope.collapsed = false

      $scope.sourceLimit = 5

      $scope.truncatingSources = ->
        $scope.getSourceCount() > $scope.sourceLimit

      $scope.showAllSources = ->
        $scope.sourceLimit = 99999

      $scope.isNewsSearch = ->
        # @Roey: Generally, a news search will always involve a single source -
        # we currently have no cases where news search returns more than one worker.
        # But we still explicitly ensure there is only one source as we are not familiar
        # with the consequences shall this condition fail (ie, more than one source with
        # the first being a news search).
        # We also check the source is decorated (isNewsSearch?) since manual sources aren't.
        $scope.getSourceCount() == 1 and $scope.sources()[0].isNewsSearch? and $scope.sources()[0].isNewsSearch()

      return

    template: require('./sourceContainer.html')
  }
